<form [formGroup]="stepForm" *ngIf="stepForm">
  <div class="col-12">
    <h5 class="nmbcol"> {{ 'Sellers.Products.AddReservation' | translate }} </h5>
    <div class="cardbg-white">
      <div class="row">
        <div class="col-6 mb-3">
          <app-image [fieldObject]="controllers['image']" [fieldErrors]="formValidator.formErrors"
            [formControlRef]="convertControls(controllers['image'].fieldName)" [productType]="productTypeId"
            [isUpdate]="isUpdate"></app-image>
        </div>
      </div>
    </div>
  </div>
  <div class="col-12">
    <div class="cardbg-white my-3">
      <div class="row">
        <div class="col-12">
          <app-reservation-ticket [fieldObject]="controllers['Ticket']" [fieldErrors]="formValidator.formErrors"
            [formControlRef]="convertControls(controllers['Ticket'].fieldName)" [productType]="productTypeId"
            [isUpdate]="isUpdate"></app-reservation-ticket>
        </div>
      </div>
    </div>
  </div>
  <div class="col-12">
    <div class="cardbg-white my-3">
      <div class="row">
        <div class="col-md-6 mb-3">
          <app-text-area [fieldObject]="controllers['Delivery_terms']" [fieldErrors]="formValidator.formErrors"
            [formControlRef]="convertControls(controllers['Delivery_terms'].fieldName)" [productType]="productTypeId"
            [isUpdate]="isUpdate"></app-text-area>
        </div>
        <div class="col-md-6 mb-3">
          <app-text-area [fieldObject]="controllers['Return_terms']" [fieldErrors]="formValidator.formErrors"
            [formControlRef]="convertControls(controllers['Return_terms'].fieldName)" [productType]="productTypeId"
            [isUpdate]="isUpdate"></app-text-area>
        </div>
      </div>
    </div>
  </div>
  <div class="cardbg-white my-3">
    <div class="row">
      <app-toggle [fieldObject]="controllers['is_buyer_info']" [fieldErrors]="formValidator.formErrors"
        [formControlRef]="convertControls(controllers['is_buyer_info'].fieldName)" [productType]="productTypeId"
        [isUpdate]="isUpdate"></app-toggle>
    </div>
  </div>
</form>
